export const Eye = ({ ...props }) => {
    return (
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9 17C12.1316 10.5825 22.4211 10.0888 26 17" stroke="#A8A8CD" strokeLinecap="round" />
            <circle cx="17.5" cy="18.5" r="3.5" fill="#A8A8CD" />
        </svg>
    );
};
